import { http } from "js/shared/utilities/http";
import validator from "validatorjs";
validator.useLang("tr");

const rules = {
    mailTo: "required",
    name: "required|max:64",
    email: "required|email",
    file: "required",
  },
  name = "İnsan Kaynakları",
  apiUrl = "/api/sendresume";

export default class HumanResources {
  constructor(mailTo, name, email, phone, message, file) {
    this.mailTo = mailTo;
    this.name = name;
    this.email = email;
    this.phone = phone;
    this.message = message;
    this.file = file;
  }

  async send(file) {
    return http.post(apiUrl, {
      mailto: this.mailTo,
      name: this.name,
      email: this.email,
      phone: this.phone,
      message: this.message,
      file,
    });
  }

  validate() {
    this.getFormData();

    let validation = new validator(this, rules);
    validation.setAttributeNames({
      mailTo: "Konu",
      name: "Adı, soyadı",
      email: "Eposta",
      file: "Dosya",
    });

    if (validation.fails()) {
      return {
        data: this,
        errors: validation.errors.errors,
      };
    } else {
      return {
        data: this,
        errors: null,
      };
    }
  }

  getAllProperty() {
    let elements = [];
    for (let key in this) {
      elements.push(key);
    }

    return elements;
  }

  getFormData() {
    let elements = this.getAllProperty();

    elements.map((element) => {
      let selector = document.getElementById(element);
      const isMultiple = selector.multiple;

      selector.classList.remove("is-invalid", "is-valid");
      selector.classList.add("is-valid");
      if (isMultiple) {
        let checkedOptions = document.querySelectorAll(
          `#${element} option:checked`
        );
        let checkedValues = Array.from(checkedOptions).map((el) => el.value);
        this[element] = checkedValues;
      } else {
        this[element] = selector.value;
      }
    });
  }

  reset() {
    let elements = this.getAllProperty();

    elements.map((element) => {
      let selector = document.getElementById(element);
      selector.classList.remove("is-invalid", "is-valid");
    });
  }

  static get name() {
    return name;
  }

  static get apiUrl() {
    return apiUrl;
  }
}
